module.exports = __webpack_public_path__ + "static/media/aiProfile.e02c8fc1.svg";